module.exports = __webpack_public_path__ + "images/antgine_LOGO.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antgine_LOGO.png
// module id = 955
// module chunks = 2